import { overloadMaybe } from '@simplisafe/ewok'
import { selectCurrentPromoDynamicDiscountCodes } from '@simplisafe/ss-ecomm-data/redux/select'
import { useSelector } from 'react-redux'

export const useCurrentPromoDynamicDiscountCodes = () => {
  const discountCodes = useSelector(selectCurrentPromoDynamicDiscountCodes) // todo: replace with useCurrentPromo
  return overloadMaybe(discountCodes)
}
